import { RotateCcw } from 'lucide-react'

// Something an automatic source brought and the editor fixed by hand: the
// collection leaves it as edited, so the CMS says so and offers the way back.
export const isHandEdited = (item: { source?: string; editorial_updated_at?: string | null }) =>
  Boolean(item.editorial_updated_at) && Boolean(item.source) && item.source !== 'manual'

export function EditedTag({ onFollow }: { onFollow?: () => void }) {
  return (
    <span className="edited-tag">
      <span className="edited-tag__label" title="A coleta automática não atualiza o que foi editado à mão.">Editado no CMS</span>
      {onFollow && <button type="button" className="text-button" onClick={onFollow}><RotateCcw size={14} /> Voltar a seguir a coleta</button>}
    </span>
  )
}
